import React from 'react';

const OrderCanceledStatus = () => {
    return (
        <div className="status__canceled">
            <h4 className="status__canceled--header">ZAMÓWIENIE ANULOWANE</h4>
            <p className="status__canceled--lead">Anulowaliśmy to zamówienie na Twoją prośbę</p>
        </div>
    );
};

export default OrderCanceledStatus;
